import { render, staticRenderFns } from "./TidbBlock.vue?vue&type=template&id=383e3398&"
import script from "./TidbBlock.vue?vue&type=script&lang=ts&"
export * from "./TidbBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports